/**
 * 为侧边栏菜单注入待审核 / 客服消息数量角标
 * 子菜单显示各自数量；父级目录（礼品卡管理、客服管理）汇总子菜单角标
 */
export function applyMenuAuditBadges(menus, counts) {
  if (!menus || !menus.length) {
    return []
  }
  const redeem = toCount(counts.redeemPending)
  const withdraw = toCount(counts.withdrawPending)
  const csUnread = toCount(counts.csUnread)
  return menus.map(item => cloneMenuWithBadge(item, redeem, withdraw, csUnread))
}

function cloneMenuWithBadge(item, redeem, withdraw, csUnread) {
  const menu = { ...item }
  menu.meta = { ...(menu.meta || {}) }

  if (menu.children && menu.children.length) {
    menu.children = menu.children.map(child => cloneMenuWithBadge(child, redeem, withdraw, csUnread))
  }

  const direct = resolveBadge(menu, redeem, withdraw, csUnread)
  const childSum = sumChildBadges(menu.children)
  const badge = direct + childSum

  if (badge > 0) {
    menu.meta.badge = badge
  } else {
    delete menu.meta.badge
  }
  return menu
}

function sumChildBadges(children) {
  if (!children || !children.length) {
    return 0
  }
  return children.reduce((sum, child) => sum + toCount(child.meta && child.meta.badge), 0)
}

function resolveBadge(menu, redeem, withdraw, csUnread) {
  const title = menu.meta && menu.meta.title
  const path = menu.path || ''
  if (title === '兑换审核' || path === 'redeem' || path.endsWith('/redeem')) {
    return redeem
  }
  if (title === '提现审核' || path === 'withdraw' || path.endsWith('/withdraw')) {
    return withdraw
  }
  if (title === '在线客服工作台' || path === 'workbench' || path.endsWith('/workbench')) {
    return csUnread
  }
  return 0
}

function toCount(value) {
  const n = Number(value)
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0
}
